import React from "react";
import ModalCreateLawyer from "./ModalCreateLawyer";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import useModal from "../../../hooks/useModal";
import { FaUserPlus } from "react-icons/fa";

const CreateLawyer = ({ refetch }) => {
    const { open, close, isOpen } = useModal();

    return(
        <div>
            <Button text={<FaUserPlus size={22} />} width="w-10" bgColor="green" onClick={open}/>
            {isOpen &&
                <Modal title="Crear abogado" onClose={close}>
                    <ModalCreateLawyer onClose={close} refetch={refetch} />
                </Modal>
            }
        </div>
    );
};

export default CreateLawyer;